import { ActionContext } from 'vuex';
import { commitSetOrdersMetrics, commitSetSelectedBranchId } from './mutations';
import { State } from '../state';
import { IUserDashboardState } from './state';
import { api } from '@/api';
import { dispatchCheckApiError } from '../main/actions';
import { IOrderMetricsParams } from '@/interfaces';
import { getStoreAccessors } from 'typesafe-vuex';


type MainContext = ActionContext<IUserDashboardState, State>;

export const actions = {
    async getOrdersMetrics(context: MainContext, params: IOrderMetricsParams) {
        try {
            const response = await api.getOrdersMetrics(context.rootState.main.token, params);
            if (response) {
                commitSetOrdersMetrics(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

};

export const { dispatch } = getStoreAccessors<IUserDashboardState, State>('');

export const dispatchGetOrdersMetrics = dispatch(actions.getOrdersMetrics);